/**
 * Color palette for the application
 * Single source of truth for all custom colors used throughout the app
 * This is used in both CSS (via globals.css @theme) and TypeScript components
 */
export const colors = {
  primary: "#000000",
  inherit: "inherit",
  transparent: "transparent",
  current: "currentColor",
  white: "#FFFFFF",
  black: "#0A0A0A",
  ash: {
    100: "#FAFAFA",
    200: "#F5F5F5",
    300: "#E5E5E5",
    400: "#A3A3A3",
    500: "#737373",
    600: "#525252",
    700: "#404040",
    800: "#262626",
    900: "#171717",
  },
  clay: {
    100: "#F6F6F3",
    200: "#EDEEE6",
    250: "#E1E1D9",
    300: "#C3C2AA",
    400: "#AAA187",
    500: "#918064",
    600: "#685948",
    700: "#483C33",
    800: "#322622",
  },
  mint: {
    100: "#ECFDF5",
    200: "#D1FAE5",
    300: "#A7F3D0",
    400: "#10B981",
    500: "#059669",
    600: "#065F46",
    700: "#064E3B",
    800: "#022C22",
  },
  honey: {
    100: "#FEF7DB",
    200: "#FEF3C7",
    300: "#FDE68A",
    400: "#FBBF24",
    500: "#F59E0B",
    600: "#D97706",
    700: "#B45309",
    800: "#78350F",
  },
  lava: {
    100: "#FEF2F2",
    200: "#FEE2E2",
    300: "#FECACA",
    400: "#F87171",
    500: "#EF4444",
    600: "#DC2626",
    700: "#B91C1C",
    800: "#7F1D1D",
  },
  rebolt: {
    100: "#FFF7ED",
    200: "#FFE2D4",
    300: "#FFBD9B",
    400: "#FF8547",
    500: "#FF5700",
    600: "#E04B00",
    700: "#B83D00",
    800: "#662200",
  },
  sky: {
    50: "#f0f9ff",
    100: "#e0f2fe",
    200: "#bae6fd",
    300: "#7dd3fc",
    400: "#38bdf8",
    500: "#0ea5e9",
    600: "#0284c7",
    700: "#0369a1",
    800: "#075985",
    900: "#0c4a6e",
    950: "#082f49",
  },
  ocean: {
    100: "#EFF6FF",
    200: "#DBEAFE",
    300: "#BFDBFE",
    400: "#60A5FA",
    500: "#3B82F6",
    600: "#2563EB",
    700: "#1E40AF",
    800: "#1E3A8A",
  },
} as const;

export type Colors = typeof colors;
